import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Box, Divider } from 'components/ui';
import checkoutUtils from 'utils/Checkout';

import GetItShippedShippingGroups from 'components/FrictionlessCheckout/ShippingMethods/GetItShippedShippingGroups';
import AutoReplenishShippingGroups from 'components/FrictionlessCheckout/ShippingMethods/AutoReplenishShippingGroups';

function ShippingGroups(props) {
    const {
        locales,
        isSdd,
        isSDDAndGiftCardOnly,
        isReplenOnly,
        isElectronicShippingGroup,
        isPhysicalGiftCard,
        standardItemsQuantity,
        shippingGroup,
        shippingGroupType,
        orderHasReplen,
        replenishItemsQuantity,
        isEditView,
        showAutoReplenishModal,
        openAutoReplenishProductsModal
    } = props;
    const isSddAndGiftCardInOrder = isSdd && !!isPhysicalGiftCard && !isSDDAndGiftCardOnly;
    const deliveryGroups = !isSddAndGiftCardInOrder
        ? checkoutUtils.computeDeliveryGroups(shippingGroup, shippingGroupType, shippingGroup?.shippingMethod, isElectronicShippingGroup)
        : checkoutUtils.computeDeliveryGroups(
            { ...shippingGroup, items: [...shippingGroup.items, ...isPhysicalGiftCard.items] },
            shippingGroupType,
            shippingGroup?.shippingMethod,
            true
        );

    return (
        <>
            {!isReplenOnly && (
                <Box
                    marginTop={[3, 3, 4]}
                    paddingX={[4, 4, 5]}
                >
                    <GetItShippedShippingGroups
                        locales={locales}
                        standardItemsQuantity={standardItemsQuantity}
                        isPhysicalGiftCard={isPhysicalGiftCard}
                        isElectronicShippingGroup={isElectronicShippingGroup}
                        shippingMethod={shippingGroup.shippingMethod}
                        deliveryGroups={deliveryGroups}
                    />
                </Box>
            )}
            {orderHasReplen && (
                <>
                    {!isReplenOnly && (
                        <Divider
                            thick={true}
                            marginY={4}
                        />
                    )}

                    <Box
                        marginTop={[3, 3, isReplenOnly ? 3 : 4]}
                        paddingX={[4, 4, 5]}
                    >
                        <AutoReplenishShippingGroups
                            locales={locales}
                            replenishItemsQuantity={replenishItemsQuantity}
                            isPhysicalGiftCard={isPhysicalGiftCard}
                            isReplenOnly={isReplenOnly}
                            shippingMethod={shippingGroup.shippingMethod}
                            deliveryGroups={deliveryGroups}
                            isEditView={isEditView}
                            showAutoReplenishModal={showAutoReplenishModal}
                            openAutoReplenishProductsModal={openAutoReplenishProductsModal}
                        />
                    </Box>
                </>
            )}
        </>
    );
}

export default wrapFunctionalComponent(ShippingGroups, 'ShippingGroups');
